import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Global error suppression for specific Bootstrap issue
const originalConsoleError = console.error;
console.error = function (...args) {
  if (args[0] && typeof args[0] === 'string' && (args[0].includes("reading 'template'") || args[0].includes("Cannot read properties of null"))) {
    return;
  }
  originalConsoleError.apply(console, args);
};

window.addEventListener('error', function (event) {
  if (event?.error?.message?.includes("reading 'template'") ||
    (event?.message && event.message.includes("reading 'template'"))) {
    event.preventDefault();
    event.stopPropagation();
    return true;
  }
}, true); // Use capture phase


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
